import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-input-dropdown',
  templateUrl: './form-input-dropdown.component.html',
  encapsulation: ViewEncapsulation.Emulated
})
export class FormInputDropdownComponent implements OnInit {
        ngOnInit(): void {
            //console.log(this.F)
        }

    @Input() F: FormControl;
    @Input() ControlName: string;
    @Input() LabelString: string;
    @Input() RequiredMessage: string;
    @Input() id: string;
    @Input() data: any;
    @Input() textField: string;
    @Input() valueField: string;
    @Input() loading: boolean = false;
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/form/form-input-dropdown.component.ts